import { render } from "./PrePostQuote.vue?vue&type=template&id=08ac5733&scoped=true"
import script from "./PrePostQuote.vue?vue&type=script&lang=js"
export * from "./PrePostQuote.vue?vue&type=script&lang=js"

import "./PrePostQuote.vue?vue&type=style&index=0&id=08ac5733&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ac5733"]])

export default __exports__